import abi from './Transactions.json';

export const contractABI = abi.abi;

export const contractAddress ='0xB8028F774705e9B314B020E4C0E5eA2a2c6617F8';